import cloudDispatcher from "../CloudDispatcher";
import articlesStore from "./ArticlesStore";

export function setMerchantId(merchantId) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_MERCHANT_ID,
    merchantId: merchantId,
  });
}

export function setArticlegroups(articlegroups) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_ARTICLEGROUPS,
    articlegroups: articlegroups,
  });
}

export function setArticles(articles) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_ARTICLES,
    articles: articles,
  });
}

export function setModifiergroups(modifiergroups) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_MODIFIERGROUPS,
    modifiergroups: modifiergroups,
  });
}

export function setModifierarticles(modifierarticles) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_MODIFIERARTICLES,
    modifierarticles: modifierarticles,
  });
}

export function setTranslations(translations) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_TRANSLATIONS,
    translations: translations,
  });
}

export function setVatOptions(vatOptions) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_VAT_OPTIONS,
    vatOptions: vatOptions,
  });
}

export function setMenugroups(menugroups) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_MENUGROUPS,
    menugroups: menugroups,
  });
}

export function setPrintgroups(printgroups) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_PRINTGROUPS,
    printgroups: printgroups,
  });
}

export function setSupergroups(supergroups) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_SUPERGROUPS,
    supergroups: supergroups,
  });
}

export function setAllergens(allergens) {
  cloudDispatcher.dispatch({
    type: articlesStore.actions.SET_ALLERGENS,
    allergens: allergens,
  });
}
